import { Flex, Space } from 'antd'
import React, { useMemo } from 'react'

import { FanReportsLabel } from '@/constants/fan-reports-chart-colors'
import { FansReports } from '@/model/analytics'

import SectionTitle from '../section-title'

import FansReportsLineChart from './fans-reports-line-chart'
import { FansReportsChartData } from './fans-reports-tooltip'


export type FansReportsNewFansProps = Partial<
  Pick<FansReports, 'activeFans' | 'activeFansComparison' | 'datesStr'>
>

export default function FansReportsTotalFans(
  { activeFans, activeFansComparison, datesStr }: FansReportsNewFansProps) {

  const data = useMemo(() => {
    if (!datesStr || !activeFans || !activeFansComparison) return []
    return datesStr.map((dateStr, i) => {
      return [
        {
          name: FanReportsLabel.ActiveFans,
          count: activeFans[i],
          growth: activeFansComparison[i],
          dateStr,
        },
      ]
    }).flat() as FansReportsChartData[]
  }, [activeFans, activeFansComparison, datesStr])

  return (
    <Flex vertical gap={16}>
      <Space>
        <SectionTitle
          title="Total fans (growth & trends)"
          tooltip="Total fan growth & trends during this period. Daily stats update at 12 AM, and monthly stats at month-end. Note: Auto-renew analysis not available for free accounts."
        />
      </Space>
      <Flex vertical>
        <FansReportsLineChart data={data} />
      </Flex>
    </Flex>
  )
}